import { render, staticRenderFns } from "./PriyomSmenaAll.vue?vue&type=template&id=010afa51&"
import script from "./PriyomSmenaAll.vue?vue&type=script&lang=js&"
export * from "./PriyomSmenaAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports